const isPlainObject = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

const deepMerge = (base, override) =>
  Object.entries(override).reduce(
    (merged, [key, value]) => ({
      ...merged,
      [key]:
        isPlainObject(value) && isPlainObject(merged[key]) ? deepMerge(merged[key], value) : value,
    }),
    base
  );

/**
 * Fills a language's namespaces with the English strings it lacks
 * (`fallback.generated.json`, written by gatsby-node.js onPreInit).
 * @param {Record<string, object>} namespaces
 * @param {Record<string, object>} fallback
 * @returns {Record<string, object>}
 */
export const withFallback = (namespaces, fallback) =>
  Object.fromEntries(
    Object.entries(namespaces).map(([ns, bundle]) => [
      ns,
      fallback[ns] ? deepMerge(fallback[ns], bundle) : bundle,
    ])
  );
